import { withStyles } from '@material-ui/core/styles';
import Link from '@material-ui/core/Link';

import Button from 'components/CncUI/Button';
import Modal from 'components/CncUI/Modal';

const styles = ({ palette, breakpoints }) => ({
  root: {
    '& .MuiDialog-paper': {
      margin: 14,
    },
  },
  title: {
    padding: '30px 40px 20px',
    [breakpoints.down('sm')]: {
      padding: '30px 20px 26px 20px',
    },
  },
  content: {
    padding: '0 40px 24px',
    maxWidth: 480,
    [breakpoints.down('sm')]: {
      padding: '0 20px 24px 20px',
    },
  },
  text: {
    color: palette.cncUI.primary.gray.primary,
    fontSize: 14,
    fontWeight: 400,
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  actions: {
    padding: '24px 40px 30px',
    [breakpoints.down('sm')]: {
      padding: '0 15px 39px 8px',
    },
  },
  link: {
    marginLeft: '0 !important',
    textDecoration: 'none !important',
  },
  button: {
    padding: '5px 32px',
    [breakpoints.down('sm')]: {
      padding: '5px',
      width: 101,
      marginRight: 'auto !important',
      marginLeft: '12px !important',
    },
  },
  continue: {
    padding: '5px 32px',
    marginLeft: '16px !important',
    '& :hover': {
      textDecoration: 'none',
    },
    [breakpoints.down('sm')]: {
      marginLeft: '12px !important',
      marginRight: 'auto !important',
      padding: '5px',
      width: 191,
    },
  },
  close: {
    marginLeft: 'auto',
    marginRight: 'auto',
  },
});

const NotPaidModal = props => {
  const { classes, type, show, onClose, setStep, isMobile } = props;
  const title = type === 'false' ? 'Heads Up!' : 'Lets Try to Find You';
  const content =
    type === 'false' ? (
      <>
        You selected "NO, I have not". This portal is ONLY for people that have
        been paid by Cast & Crew, CAPS, or Media Services.
        <br />
        <br />
        Please contact customer support.
      </>
    ) : (
      <>
        This portal is ONLY for people that have been paid by Cast & Crew, CAPS,
        or Media Services. You selected "I don't remember".
        <br />
        <br />
        You can contact customer support or select continue and we'll do our
        best to find you in our system. If we are unable to validate your
        identity you will not receive a registration email.
      </>
    );

  return (
    <Modal
      open={show}
      onClose={onClose}
      id="NotPaidModal"
      className={classes.root}
    >
      <Modal.Title className={classes.title}>{title}</Modal.Title>
      <Modal.Content className={classes.content}>
        <Modal.ContentText id="NotPaidModalMessage">
          {content}
        </Modal.ContentText>
      </Modal.Content>
      <Modal.Actions className={classes.actions}>
        {(type === 'false' || !isMobile) && (
          <Button
            secondary
            onClick={onClose}
            className={classes.button}
            id="NotPaidModalCloseButton"
          >
            Close
          </Button>
        )}
        <Link
          id="NotPaidModalCustomerSupportLink"
          className={classes.link}
          target="_blank"
          rel="noopener noreferrer"
          href="https://www.castandcrew.com/support/production-employee-support/"
          color="inherit"
        >
          <Button
            secondary={!(type === 'false')}
            onClick={onClose}
            className={classes.continue}
            id="NotPaidModalCustomerSupportButton"
          >
            Go to Customer Support
          </Button>
        </Link>
        {type === 'maybe' && (
          <Button
            onClick={() => {
              setStep('FindAccount');
            }}
            className={classes.continue}
            id="NotPaidModalContinueButton"
          >
            Continue
          </Button>
        )}
      </Modal.Actions>
      {type === 'maybe' && isMobile && (
        <Modal.Actions>
          <div
            id="NotPaidModalClose"
            onClick={onClose}
            className={classes.text}
          >
            Close
          </div>
        </Modal.Actions>
      )}
    </Modal>
  );
};

export default withStyles(styles)(NotPaidModal);
